import { FC } from 'react'
import { times } from 'lodash'
import { CheckIcon } from 'lucide-react'
import { useAppSelector } from '../../../../redux'
import { getIconFromString } from '../../../../utils'
import { StyledCoursePreviewIncludes } from '.'

const CoursePreviewIncludes: FC = () => {
  const { course, loading } = useAppSelector((state) => state.course)

  return (
    <StyledCoursePreviewIncludes $loading={loading}>
      <div className="width-controller">
        <div className="section-content">
          <h2>This course includes:</h2>
          <ul>
            {!loading &&
              course?.includesDescription?.map((point) => {
                return (
                  <li key={point.label}>
                    {getIconFromString(point.icon) || <CheckIcon />}
                    {point.label}
                  </li>
                )
              })}
            {loading &&
              times(5, (index) => {
                return (
                  <li key={index}>
                    <div />
                  </li>
                )
              })}
          </ul>
        </div>
      </div>
    </StyledCoursePreviewIncludes>
  )
}

export default CoursePreviewIncludes
